export default "__VITE_ASSET__BotrbqZ0__"